import * as React from 'react';
import { CheckOutline, CheckFilled, InfoFilled, InfoOutline, WarningFilled, WarningOutline, ErrorFilled, ErrorOutline } from './icon';
export var AntdIcon = function (_a) {
    var type = _a.type, _b = _a.isFilled, isFilled = _b === void 0 ? false : _b;
    switch (type) {
        case 'success':
            return isFilled ? React.createElement(CheckFilled, null) : React.createElement(CheckOutline, null);
        case 'info':
            return isFilled ? React.createElement(InfoFilled, null) : React.createElement(InfoOutline, null);
        case 'warning':
            return isFilled ? React.createElement(WarningFilled, null) : React.createElement(WarningOutline, null);
        case 'error':
            return isFilled ? React.createElement(ErrorFilled, null) : React.createElement(ErrorOutline, null);
        default:
            return isFilled ? React.createElement(CheckFilled, null) : React.createElement(CheckOutline, null);
    }
};
